export const mockFieldValues = [
  {
    key: 'aa1',
    value: 'John Smith',
  },
  {
    key: 'aa2',
    value: 'writer',
  },
  {
    key: 'aa3',
    value: 'John',
  },
  {
    key: 'aa4',
    value: 'Smith',
  },
  {
    key: 'aa5',
    value: 'test@wix.com',
  },
  {
    key: '6aa',
    value: '+37069999999',
  },
  {
    key: '7aa',
    value: new Date(1990, 5, 17),
  },
  {
    key: '8aa',
    value: 'Tel Aviv',
  },
  {
    key: '9aa',
    value: null,
  },
  {
    key: '10aa',
    value: 'Shoe Size',
  },
  {
    key: '11aa',
    value: 'Pet Name',
  },
  {
    key: '12aa',
    value: 'https://www.facebook.com/zuck',
  },
  {
    key: '13aa',
    value: 'https://www.instagram.com/',
  },
  {
    key: '14aa',
    value: 'https://twitter.com/test',
  },
];
